// extracted by mini-css-extract-plugin
module.exports = {"postsContainer":"tags-module--posts-container--3Dd6W","tagsContainer":"tags-module--tags-container--Xw43-"};